const PASSWORD = "Remax@123";
const SESSION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
const SESSION_KEY = "dev_auth_remax";
const AUTH_TIMESTAMP_KEY = "auth_timestamp_remax";
const PRODUCTION_URL = "https://remaxrd.com";
const STAGE_ENVIRONMENT = "stage";
const LOCALHOST_ENVIRONMENT = "localhost";

export {
  PASSWORD,
  SESSION_TIMEOUT,
  SESSION_KEY,
  AUTH_TIMESTAMP_KEY,
  PRODUCTION_URL,
  STAGE_ENVIRONMENT,
  LOCALHOST_ENVIRONMENT,
};
